import { createSelector } from "reselect";
import { INIT_STATE } from "./reducer";
import { TUser } from "../../../common/types/user";

export const selectAuthUserDomain = (state) => state.Login || INIT_STATE;

export const selectAuthUserDetails = () =>
    createSelector(selectAuthUserDomain, ({ authUser }): TUser => authUser);

export const selectIsAuthUserDetailsLoading = () =>
    createSelector(selectAuthUserDomain, ({ isLoading }): boolean => isLoading);

export const selectIsAuthUserNotRegistered = () =>
    createSelector(selectAuthUserDomain, ({ isNotRegisteredUser }): boolean => isNotRegisteredUser);

export const selectIsRegistrationInProgress = () =>
    createSelector(selectAuthUserDomain, ({ isRegistrationInProgress }): boolean => isRegistrationInProgress);

export const selectIsRegistrationFailed = () =>
    createSelector(selectAuthUserDomain, ({ isRegistrationFailed }): boolean => isRegistrationFailed);
